import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "type",
    "mxPriorityGroup",
    "mxPriorityInput",
    "proxiedGroup",
    "proxiedInput",
    "contentTextGroup",
    "contentTextInput",
    "contentTextareaGroup",
    "contentTextareaInput"
  ]

  connect() {
    this.toggleFormControls()
  }

  toggleFormControls() {
    const selectedType = this.typeTarget.value
    const mxSelected = selectedType === "MX"
    const proxiedSupported = selectedType === "A" || selectedType === "CNAME"
    const txtSelected = selectedType === "TXT"

    this.mxPriorityGroupTarget.classList.toggle("d-none", !mxSelected)
    this.mxPriorityInputTarget.disabled = !mxSelected

    this.proxiedGroupTarget.classList.toggle("d-none", !proxiedSupported)
    this.proxiedInputTarget.disabled = !proxiedSupported

    this.contentTextGroupTarget.classList.toggle("d-none", txtSelected)
    this.contentTextInputTarget.disabled = txtSelected

    this.contentTextareaGroupTarget.classList.toggle("d-none", !txtSelected)
    this.contentTextareaInputTarget.disabled = !txtSelected
  }
}
